<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
        <div class="container-fluid mt--9">
            <div class="row">
                <div class="col">
                    <div class="card shadow" v-if="loadingPO">
                        <div class="col-sm-12 mt-4 mb-4" style="">
                            <center>
                                <img
                                src="img/loader.gif"
                                class="img-responsive"
                                style="width: 40px"
                                /><br />Cargando Información...
                            </center>
                        </div>
                    </div>
                    <div class="card shadow " v-if="!loadingPO && emptyPO">
                        <div class="col-sm-12 mt-6 mb-6" style="">
                            <center>
                                <h2>Orden de compra no encontrada en SAP...</h2>
                            </center>
                        </div>
                    </div>
                    <div class="card shadow" v-if="!loadingPO && !emptyPO">
                        <!-- Modal para poder cambiar el valor de un campo a multiples lineas -->
                        <b-modal hide-footer  v-model="showModalEditMultiple" size="md" title="Edición multiple" centered>
                            <div class="row">
                                <div class="col-sm-12">
                                    <label>¿Qué campo deseas modificar?</label>
                                    <multiselect
                                        v-model="fieldSelected"
                                        :options="fieldOptions"
                                        label="text"
                                        track-by="value"
                                        placeholder="Selecciona un campo"
                                    ></multiselect>
                                </div>
                            </div>
                            <div class="row mt-2" v-if="fieldSelected">
                                <div class="col-sm-12" v-if="fieldSelected.value != 'U_FollowUp' && fieldSelected.value != 'U_FechaConf' && fieldSelected.value != 'ShipDate' && fieldSelected.value != 'U_Real_Load_Date'">
                                    <label>Valor</label>
                                    <base-input v-model="valueToChange" placeholder="Escribe el valor del campo" style="transform: scale(1.0);transform-origin:left;margin-bottom:3px;"></base-input>
                                </div>
                                <div class="col-sm-12" v-if="fieldSelected.value === 'U_FollowUp'">
                                    <label>Valor</label>
                                    <multiselect
                                        v-model="valueToChange"
                                        :options="seguimientoOptions"
                                        label="Description"
                                        track-by="Value"
                                        placeholder="Selecciona un valor"
                                    ></multiselect>
                                </div>
                                <div class="col-sm-12" v-if="fieldSelected.value == 'U_FechaConf' || fieldSelected.value == 'ShipDate' || fieldSelected.value == 'U_Real_Load_Date'">
                                    <label>Valor</label>
                                    <base-input style="cursor:pointer;">
                                        <flat-picker slot-scope="{focus, blur}"
                                            @on-open="focus"
                                            @on-close="blur;"
                                            :config="{allowInput: true}"
                                            class="form-control datepicker"
                                            v-model="valueToChange"
                                            style="cursor:pointer;padding-left:20px">
                                        </flat-picker>
                                    </base-input>
                                </div>
                            </div>
                            <div class="mt-2">
                                <base-button
                                    style="float: right"
                                    tag="a"
                                    type="primary"
                                    href="#"
                                    class="active"
                                    role="button"
                                    aria-pressed="true"
                                    @click="setChanges"
                                    >Definir cambios</base-button
                                >
                            </div>
                        </b-modal>
                        <div class="card-header bg-transparent">
                            <div class="row">
                                <div class="col-sm-2">
                                    <h3 class="mb-0">Orden de Compra</h3>
                                    <!--<base-button type="danger" @click="modals.newTicket = true">Crear Nuevo
                                    </base-button>-->
                                </div>
                                
                            </div>
                        </div>
                        <div class="table-responsive" style="padding-top:10px" v-if="selectedPO">
                            <div class="row ml-3">
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">No.</span> <br>
                                    <span style="font-size:18px;"> <strong>{{selectedPO.DocNum}}</strong></span>
                                </div>
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">Fecha de documento</span> <br>
                                    <span style="font-size:18px;"> <strong>{{selectedPO.DocDate}}</strong></span>
                                </div>
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">Fecha de Necesidad</span> <br>
                                    <span style="font-size:18px;"> <strong>{{selectedPO.DocDueDate}}</strong></span>
                                </div>
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">Fecha de Contabilización</span> <br>
                                    <span style="font-size:18px;"> <strong>{{selectedPO.TaxDate}}</strong></span>
                                </div>
                                
                            </div>
                            <div class="row mt-3 ml-3">
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">Proveedor</span> <br>
                                    <span style="font-size:18px;"> <strong>{{selectedPO.CardCode}} | {{selectedPO.CardName}}</strong></span>
                                </div>
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">Iniciales Almacenista</span> <br>
                                    <span style="font-size:18px;"> <strong>{{selectedPO.U_Initials}}</strong></span>
                                </div>
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">Total</span> <br>
                                    <span style="font-size:18px;"> <strong>{{new Intl.NumberFormat('mx-MX', { style: 'currency', currency: selectedPO.DocCurrency }).format(selectedPO.DocTotalFc)}}</strong></span>
                                </div>
                                <div class="col-sm-3">
                                    <span style="font-size:14px;">Moneda</span> <br>
                                    <span style="font-size:18px;"> <strong>{{selectedPO.DocCurrency}} | {{new Intl.NumberFormat('mx-MX', { style: 'currency', currency: 'MXN' }).format(selectedPO.DocRate)}} </strong></span>
                                </div>
                                
                            </div>
                        </div>
                        <base-button v-if="!loadingPatch" class="m-3" outline type="default" @click="showModalEditMultiple=true">Definir modificación multiple con lineas seleccionadas</base-button>
                        <div class="table-responsive">
                            <hr>
                            <h4 v-if="!loadingPatch" class="ml-3 mt-4">Selecciona las lineas que desees hacer multiples modificaciones:</h4>
                            <base-table v-if="!loadingPatch" thead-classes="thead-light" class="mt-2" :data="selectedPO.DocumentLines">
                                <template slot="columns">
                                    <th>
                                        <center>
                                            <base-checkbox v-model="selectAll" v-on:input="selectDeselectAll(selectAll)"></base-checkbox>
                                        </center>
                                    </th>
                                    <th><center>LineNum</center></th>
                                    <th><center>Artículo</center></th>
                                    <th><center>Cantidad / Unidad</center></th>
                                    <th><center>Almacén</center></th>
                                    <th><center>Precio Unitario / <br> TaxCode</center></th>
                                    <th><center>Total</center></th>
                                    <th><center>Fecha de <br>llegada</center></th>
                                    <th><center>CEDIS <br>destino</center></th>
                                    <th><center>Shipment ID</center></th>
                                    <th><center>Info de <br>rastreo</center></th>
                                    <th><center>Seguimiento</center></th>
                                    <th><center>Fecha Conf</center></th>
                                    <th><center>Texto Libre</center></th>
                                    <th><center>Pedimento</center></th>
                                    <th><center># ST</center></th>
                                    <th><center>Fecha Real</center></th>

                                    <th></th>
                                </template> 
                                <template slot-scope="{ row, index }">
                                <th scope="row" >
                                    <center>
                                        <base-checkbox class="mt-1" v-model="row.edit" v-if="row.LineStatus === 'bost_Open'"></base-checkbox>
                                        <!-- <input type="checkbox" style="transform: scale(1);transform-origin:left;margin-bottom:3px;" v-model="row.edit" > -->
                                    </center>
                                </th>
                                <th scope="row">
                                        <center>
                                            <a style="font-size: 12px">{{ row.LineNum }} </a>
                                        </center>
                                    </th>
                                <th scope="row">
                                    <center>
                                        <a style="font-size: 12px">{{ row.ItemCode }} </a> <br>
                                        <a style="font-size: 9px">{{ row.ItemDescription }}</a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                        <!-- <base-input v-model="row.Quantity" style="transform: scale(0.75);transform-origin:left;margin-bottom:-15px;" type="number" @change="onChangeQty(index)" v-if="row.LineStatus === 'bost_Open'"></base-input><br> -->
                                        <a style="font-size: 14px">{{row.Quantity}}<br></a>
                                        <a style="font-size: 9px">{{ row.UoMCode }} - {{ row.MeasureUnit }}</a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.WarehouseCode }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                        <!-- <base-input v-model="DocumentLinesToShow[index].UnitPriceToShow" style="transform: scale(0.75);transform-origin:left;margin-bottom:-15px;" type="number" @change="onChangeUnitPrice(index)"  v-if="row.LineStatus === 'bost_Open'"></base-input> <br>-->
                                        <a style="font-size: 14px">{{DocumentLinesToShow[index].UnitPriceToShow.toFixed(2)}}<br></a>
                                        <a style="font-size: 12px">{{ row.TaxCode }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{new Intl.NumberFormat('mx-MX', { style: 'currency', currency: selectedPO.DocCurrency }).format(DocumentLinesToShow[index].RowTotalFC)}} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.ShipDate }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{row.U_Issue_ValidatedComment}}</a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.U_TS_Marca }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.U_TrackingInfoPO }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ seguimientoOptions.find((item) => item.Value === row.U_FollowUp).Description }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.U_FechaConf }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.FreeText }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.U_PedimentNum }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                    <a style="font-size: 12px">{{ row.U_Issue_ValidatedQty }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                        <a style="font-size: 12px">{{ row.U_Real_Load_Date }} </a>
                                    </center>
                                </th>
                                <th scope="row">
                                    <center>
                                        <a
                                            href="#"
                                            class="btn btn-icon-only"
                                            style="color: red; cursor: pointer"
                                            v-b-tooltip.hover
                                            title="Eliminar linea"
                                            @click="removeLine(index)"
                                        >
                                            <i class="fas fa-trash"></i>
                                        </a>
                                    </center>
                                </th>
                                
                                </template>
                            </base-table>
                            
                        </div>
                        <base-button v-if="!loadingPatch" class="ml-3 mr-3 mt-1 mb-3 active" @click="saveChanges" tag="a" type="primary" size="lg" href="#" role="button" aria-pressed="true">Guardar cambios</base-button>
                        <div class="col-sm-12 mt-4 mb-4" style="" v-if="loadingPatch">
                            <center>
                                <img
                                src="img/loader.gif"
                                class="img-responsive"
                                style="width: 40px"
                                /><br />Guardando cambios en SAP...
                            </center>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
</style>

<script>
import { getAuth } from "firebase/auth";
import Multiselect from "vue-multiselect";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axios from 'axios'

export default {
    components: {
        Multiselect,
        flatPicker
    },
    created(){
        axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
    },
    beforeMount() {
        /**
         * * Function to Set Permissions
         */
         const user = getAuth().currentUser;

        if( user.email != 'brendaterrazas@canplast.com.mx' && 
            user.email != 'edricbaeza@canplast.com.mx' && 
            user.email != 'elesbantrevizo@canplast.com.mx' && 
            user.email != 'aaronroman@canplast.com.mx' && 
            user.email != 'daliahernandez@canplast.com.mx' && 
            user.email != 'dianaquinonez@canplast.com.mx' && 
            user.email != 'yeseniaarellanes@canplast.com.mx' && 
            user.email != 'alfredoreyes@canplast.com.mx' && 
            user.email != 'idalyvillalobos@canplast.com.mx' && 
            user.email != 'estefaniasalas@canplast.com.mx' &&
            user.email != 'concepcionnuno@canplast.com.mx' &&
            user.email != 'leslysifuentes@canplast.com.mx'
        ){
            this.$swal.fire({
                title: "Error",
                text: "No tienes permisos para acceder a esta página",
                icon: "error",
                showConfirmButton: true,
            })
            this.$router.push({ path: '/' })
        }
    },
    data() {
        return {
            sidebarBackground: "vue", //vue|blue|orange|green|red|primary
            user: null,
            tableData: [],
            filterData: [],
            searchByDocNum: null,
            showPO: false,
            loadingPO: true,
            selectedPO: null,
            seguimientoOptions:[],
            selectAll: false,
            showModalEditMultiple: false,
            fieldSelected: null,
            valueToChange: null,
            fieldOptions: [
                {
                    value: "ShipDate",
                    text: "Fecha de Llegada"
                },
                {
                    value: "U_TS_Marca",
                    text: "Shipment ID"
                },
                {
                    value: "U_FollowUp",
                    text: "Seguimiento"
                },
                {
                    value: "U_FechaConf",
                    text: "Fecha de Confirmación"
                },
                {
                    value: "FreeText",
                    text: "FreeText"
                },
                {
                    value: "U_PedimentNum",
                    text: "Pedimento"
                },
                {
                    value: "U_TrackingInfoPO",
                    text: "Información de rastreo"
                },
                {
                    value: "U_Issue_ValidatedComment",
                    text: "CEDIS"
                },
                {
                    value: "U_Issue_ValidatedQty",
                    text: "ST"
                },
                {
                    value: "U_Real_Load_Date",
                    text: "Fecha Real"
                }
            ],
            loadingPatch: false,
            emptyPO: false,
            DocumentLinesToShow: [],
        }
    },
    mounted() {
        setTimeout(() => {
            console.log("query", this.$route.query.DocNum);
            /**
             * * Se obtienen las opciones validas para el campo U_FollowUp
             */
            axios.get(`/api/user_fields/FollowUp`).then(response => {
                this.seguimientoOptions = response.data.value[0].ValidValuesMD;
                /**
                 * * Se obtienen los datos de la orden de compra
                 */
                axios.get(`/api/purchase_orders/dn/${this.$route.query.DocNum}`).then(response => {
                    console.log("🚀 ~ file: PurchaseOrders.vue ~ line 235 ~ axios.get ~ response", response)
                    if(response.data.value.length>0){
                        this.selectedPO = response.data.value[0];
                        this.DocumentLinesToShow = response.data.value[0].DocumentLines
                        if(this.selectedPO.DocCurrency="EUR" || this.selectedPO.DocCurrency=="USD"){
                            this.selectedPO.DocumentLines.forEach((element, index) => {
                                let UnitPriceFC = element.UnitPrice / this.selectedPO.DocRate;
                                console.log("🚀 ~ file: PurchaseOrder.vue ~ line 373 ~ this.selectedPO.DocumentLines.forEach ~ UnitPriceFC", UnitPriceFC)
                                this.DocumentLinesToShow[index].UnitPriceToShow = parseFloat(UnitPriceFC)
                            });   
                        }
                        this.loadingPO = false;
                    }
                    else{
                        this.emptyPO = true;
                        this.loadingPO = false;
                    }
                    
                })
                .catch((err) => {
                    console.log("🚀 ~ file: PurchaseOrders.vue ~ line 178 ~ getEntries ~ err", err)
                });
            })
            .catch((err) => {
                console.log("🚀 ~ file: PurchaseOrders.vue ~ line 178 ~ getEntries ~ err", err)
            });
        }, 1000);
    },
    methods: {
        /**
         * * Metodo para mostrar el total actualizado cuando cambian la cantidad
         * */
        onChangeQty(index){
            this.selectedPO.DocumentLines[index].RowTotalFC = parseFloat(this.selectedPO.DocumentLines[index].Quantity * this.DocumentLinesToShow[index].UnitPriceToShow);
        },
        /**
         * * Metodo para mostrar el total actualizado cuando cambian el precio
         * */
        onChangeUnitPrice(index){
            this.selectedPO.DocumentLines[index].UnitPrice = parseFloat(parseFloat(this.DocumentLinesToShow[index].UnitPriceToShow) * parseFloat(this.selectedPO.DocRate));
            this.selectedPO.DocumentLines[index].RowTotalFC = parseFloat(this.selectedPO.DocumentLines[index].Quantity * this.DocumentLinesToShow[index].UnitPriceToShow);
            console.log("🚀 ~ file: PurchaseOrder.vue ~ line 407 ~ onChangeUnitPrice ~ this.selectedPO.DocumentLines[index]", this.selectedPO.DocumentLines[index])
        },
        /**
         * * Metodo para llamar al API de Canplast para guardar los cambios de la Purchase Order en Service Layer
         * */
        saveChanges(){
            console.log("🚀 ~ file: PurchaseOrder.vue ~ line 359 ~ .then ~ DocumentLInes", this.selectedPO.DocumentLines)
            this.$swal.fire({
                title: `¿Quieres guardar los cambios de la OC ${this.selectedPO.DocNum}?`,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: `Si`,
                cancelButtonText: "No",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.loadingPatch = true;
                    /**
                     * * elimina el atributo edit, en todas las lineas de la orden de compra
                     */
                    this.selectedPO.DocumentLines.forEach((element, index) => {
                        delete this.selectedPO.DocumentLines[index].edit;
                    });
                    let json = {
                        DocumentLines:{
                            DocumentLines: this.selectedPO.DocumentLines
                        }
                    }
                    console.log("🚀 ~ file: PurchaseOrder.vue ~ line 366 ~ .then ~ json", json)
                    axios.patch(`/api/purchase_orders/${this.selectedPO.DocEntry}`,JSON.parse(JSON.stringify(json))).then(response => {
                        console.log("🚀 ~ file: PurchaseOrder.vue ~ line 364 ~ axios.patch ~ response", response)
                        if(response.data.result == "OK"){
                            this.$swal.fire({
                                title: "Cambios guardados",
                                text: "",
                                icon: "success",
                                showConfirmButton: false,
                                timer: 2000
                            }).then(()=>{
                                this.loadingPatch = false;
                                location.reload() 
                            })
                        }
                        else if(response.data.sl_err){
                            this.$swal.fire({
                                title: "Error",
                                text: response.data.sl_err.error.message.value,
                                icon: "error",
                                showConfirmButton: true,
                            })
                            this.loadingPatch = false;
                        }

                    })
                    .catch((err) => {
                        console.log("🚀 ~ file: PurchaseOrder.vue ~ line 368 ~ .then ~ err", err)
                    });
                }
            });
        },
        /**
         * * Metodo para eliminar un document line de la Purchase Order
         * */
        removeLine(index){
            console.log("🚀 ~ file: PurchaseOrder.vue ~ line 315 ~ removeLine ~ index", index)
            this.$swal.fire({
                title: `¿Quieres eliminar el articulo ${this.selectedPO.DocumentLines[index].ItemCode}?`,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: `Si`,
                cancelButtonText: "No",
            })
            .then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.selectedPO.DocumentLines.splice(index, 1);
                }
            });
        },
        /**
         * * Este metodo le hace los cambios a todas las lineas seleccionadas en el campo que el usuario eligio
         * */
        setChanges(){
            const fieldSelected = this.fieldSelected;
            console.log("🚀 ~ file: PurchaseOrder.vue ~ line 275 ~ setChanges ~ fieldSelected", fieldSelected)
            const valueToChange = this.valueToChange;
            console.log("🚀 ~ file: PurchaseOrder.vue ~ line 277 ~ setChanges ~ valueToChange", valueToChange)
            if(fieldSelected.value != 'U_FollowUp'){
                this.selectedPO.DocumentLines.forEach((line, index) => {
                    if(line.edit){
                        this.selectedPO.DocumentLines[index][fieldSelected.value] = valueToChange;
                        this.selectedPO.DocumentLines[index].edit = false;
                    }
                    if(this.selectedPO.DocumentLines.length == index + 1){
                        this.showModalEditMultiple = false;
                        this.fieldSelected = null;
                        this.valueToChange = null;
                        this.selectAll = false;
                    }
                });
            }
            else if(fieldSelected.value == 'U_FollowUp'){
                this.selectedPO.DocumentLines.forEach((line, index) => {
                    if(line.edit){
                        this.selectedPO.DocumentLines[index][fieldSelected.value] = valueToChange.Value;
                        this.selectedPO.DocumentLines[index].edit = false;
                    }
                    if(this.selectedPO.DocumentLines.length == index + 1){
                        this.showModalEditMultiple = false;
                        this.fieldSelected = null;
                        this.valueToChange = null;
                        this.selectAll = false;
                    }
                });
            }
        },
        /*
        * * Method to select/deselect all rows in the table to edit
         */
        selectDeselectAll(data){
            this.selectedPO.DocumentLines.forEach((element, index) => {
                this.selectedPO.DocumentLines[index].edit = data;
            });
        },
    },
    computed:{
        filteredAndSorted(){
            const res = this.filterData.filter(po => {
                return po.PurchaseOrders.includes(this.searchByDocNum)
            })
            return res   
        }
    }
};
</script>